import type { ReactNode } from 'react';

export const symbol_nfc: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M690-240q12.75 0 21.38-8.63Q720-257.25 720-270v-420q0-12.75-8.62-21.38Q702.75-720 690-720H510q-26 0-43 17t-17 43v128q-15 8.56-22.5 21.78T420-480q0 26 17 43t43 17q26 0 43-17t17-43q0-17.35-8-30.18Q524-523 510-532v-128h150v360H300v-360h83q12.75 0 21.38-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.38-8.5H270q-12.75 0-21.37 8.62Q240-702.75 240-690v420q0 12.75 8.63 21.37Q257.25-240 270-240h420ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Z"
		/>
	</svg>
);
